import OfertaManagementPage from '../pages/OfertaManagementPage'

const routes = [
    { name: 'OfertaManagementPage', path: '/oferta-management', component: OfertaManagementPage },
]

export default routes;

